import React, { useEffect, useState } from "react";
// import { MDBDataTable } from "mdbreact"
import { Row, Col, Card, CardBody, CardTitle, CardSubtitle, Button, Modal, ModalBody, } from "reactstrap";
// import "./Card.scss";
import '../Icons/IconFontawesome';
import Utils from '../Utility';
import { post, get, put } from "../../helpers/api_helper";
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import DeleteModal from './DeleteModal';
import DataTable from 'react-data-table-component';
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from 'react-toastify';
import Multiselect from 'multiselect-react-dropdown';
import AddOppor from '../Forms/AddOppor';
const { io } = require("socket.io-client");

const LeadSingle = (props) => {
  const { user, singleId, setLoading } = props;
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [modalData, setModalData] = useState({ type: "Delete" });
  const [isOpporForm, setIsOpporForm] = useState(false);
  const [form, setForm] = useState(false);
  const [opporOptions, setOpporOptions] = useState([]);
  const [selectedOppor, setSelectedOppor] = useState([]);


  useEffect(() => {
    console.log('oppor id on single oppor', singleId);
    if (user && singleId) {
      getData();
    }
  }, [user, singleId]);

  const getData = async () => {
    get("/comp/detail?companyId=" + singleId, { token: user?.token })
      .then(json => {
        console.log('response from get comp single', json);
        if (json?.statusCode == 200) {
          setData(json?.data);
          let opt = [];
          json?.data?.oppor?.map((item) => {
            opt.push({ name: item.title, id: item?._id });
          })
          setOpporOptions(opt);
          setColumns([
            {
              name: 'Name',
              selector: row => row.name,
            },
            {
              name: 'Email',
              selector: row => row.email,
            },
            {
              cell: (row) => row.oppor.map((item) => {
                console.log('item, ', item?.title);
                return (
                  <div className="d-flex">
                    <span>{item?.title}, </span>
                  </div>
                )
              }),
              name: 'Opportunities',
              ignoreRowClick: true,
              // allowOverflow: true,
              // button: true,
            },
            {
              name: 'Created At',
              selector: row => row.createdAt,
            },
            {
              cell: (row) => <>
                <Button onClick={() => handleDeleteCred(row)}
                  title={"Delete"}
                  style={{ backgroundColor: user?.company?.theme ? user?.company?.theme : Utils.themeColor, marginRight: 10, padding: 5, paddingLeft: 8, paddingRight: 8 }}><span className="mdi mdi-delete" style={{ fontSize: 20 }}></span></Button>
              </>,
              name: 'Action',
              ignoreRowClick: true,
              // allowOverflow: true,
              // button: true,
            },
          ])
        }
      })
      .catch(error => {
        console.log('error while getting lead detail', error);
      })
  }

  const handleValidSubmit = (e, values) => {
    console.log('values ', values);
    if (selectedOppor.length < 1) {
      toast.error('Select at least one Opportunity');
      return;
    }
    let temp = [];
    selectedOppor.map((item) => {
      temp.push(item.id);
    });
    let body = {
      ...values,
      companyId: data?._id,
      opporIds: temp,
      companyName: data?.title,
      addedBy: user?._id,
      token: user?.token
    };
    setLoading(true);
    post('/user/add', body)
      .then(json => {
        setLoading(false);
        if (json.statusCode == 200) {
          setForm(false);
          toast.success(json?.message);
          getData();
        } else {
          toast.error(json?.error);
        }
      })
      .catch(error => {
        setLoading(false);
        console.log('error', error);
        toast.error("Something Went Wrong");
      })
  }

  const handleDeleteCred = (cred) => {
    console.log('cred need to delete', cred);
    setModalData(cred);
    setDeleteModal(true);
  }

  const onDelete = () => {
    setLoading(true);
    post("/user/delete", { userId: modalData?._id, token: user?.token })
      .then(json => {
        console.log('response from delete user', json);
        setLoading(false);
        if (json.statusCode == 200) {
          toast.success(json?.message);
          getData();
          setDeleteModal(false);
          setModalData(null);
        } else
          toast.error(json?.error);
      })
      .catch(error => {
        setLoading(false);
        toast.error('Something Went Wrong');
        console.error('error while deleting user', error);
      })
  }

  const handleChangeInput = (list) => {
    setSelectedOppor(list);
  }

  return (
    <React.Fragment>
      <Row>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={() => onDelete()}
          onCloseClick={() => setDeleteModal(false)}
        />
        <Modal isOpen={form} toggle={() => setForm(false)} centered={true}>
          <ModalBody className="py-3 px-5">
            <h5 className="text-black font-size-20">Add Credential !</h5>
            <div className="p-2">
              <AvForm
                className="form-horizontal"
                onValidSubmit={(e, v) => {
                  handleValidSubmit(e, v)
                }}
              >
                <div className="mb-3">
                  <AvField
                    name="name"
                    label="Name"
                    className="form-control"
                    placeholder="Enter name"
                    type="text"
                    required
                  />
                </div>
                <div className="mb-3">
                  <AvField
                    name="email"
                    label="Email"
                    className="form-control"
                    placeholder="Enter email"
                    type="email"
                    required
                  />
                </div>

                <div className="mt-4">
                  <Multiselect
                    options={opporOptions}
                    onSelect={(selectedList, selectedItem) => handleChangeInput(selectedList)}
                    onRemove={(selectedList, removedItem) => handleChangeInput(selectedList)}
                    displayValue="name"
                    placeholder={"Select Opportunities"}
                    showCheckbox
                    name="Opportunities"
                  />
                </div>
                <div className="mt-4">
                  <Row>
                    <Col md={6}>
                      <button
                        className="btn btn-primary w-100 waves-effect waves-light"
                        style={{ backgroundColor: Utils.themeColor }}
                        onClick={() => setForm(false)}
                        type="reset"
                      >
                        Cancel
                      </button>
                    </Col>
                    <Col md={6}>
                      <button
                        className="btn btn-primary w-100 waves-effect waves-light"
                        type="submit"
                        style={{ backgroundColor: Utils.themeColor }}
                      >
                        Add
                      </button>
                    </Col>
                  </Row>
                </div>
              </AvForm>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={isOpporForm} toggle={() => setIsOpporForm(false)} centered={true} style={{ minWidth: 'max-content' }}>
          <ModalBody className="py-3 px-5">
            <AddOppor
              role={"Opportunities"}
              user={user}
              close={setIsOpporForm}
              setCurrentUser={getData}
              setLoading={setLoading}
            />
          </ModalBody>
        </Modal>
        <Row>
          <Col xl={12}>
            <Row className="d-flex justify-content-between">
              <Col md={6}>
                <span style={{ color: 'black', fontWeight: 'bold', fontSize: 20 }}>{data?.title} <span style={{ fontSize: 16, color: 'gray', fontWeight: 'normal', textTransform: 'capitalize' }}>({data?.createdAt})</span></span>
              </Col>
              <Col md={6} className="d-flex justify-content-end align-items-center" >
                <div style={{ textAlignLast: 'right', marginRight: 10 }}>
                  <Button style={{ backgroundColor: Utils.themeColor }} onClick={() => {props?.setCurrentUser(data); props?.setIsAddForm(true);}}>
                    Update
                  </Button>
                </div>
                <div style={{ textAlignLast: 'right' }}>
                  <Button style={{ backgroundColor: Utils.themeColor }} onClick={() => props?.history.replace("/company")}>
                    Back
                  </Button>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col>
            <Card className="p-3">
              <CardTitle><h5>Description</h5></CardTitle>
              <div className="d-flex">
                <span className="me-1">{data?.desc}</span>
              </div>
            </Card>
            <Card className="p-3">
              <CardTitle><h5>Establishment Details</h5></CardTitle>
              <Row className="justify-content-around">
                <Col md={3}>
                  <p className="m-0"><b>Company ID : </b>{data?.compId}</p>
                  <p className="m-0"><b>Code : </b>{data?.code}</p>
                </Col>
                <Col md={3}>
                  <p className="m-0"><b>Type : </b>{data?.type}</p>
                  <p className="m-0"><b>Strength : </b>{data?.strength}</p>
                </Col>
                <Col md={3}>
                  <p className="m-0"><b>Operating states : </b>{data?.operatingState}</p>
                  <p className="m-0"><b>Working Day : </b>{data?.workingDay}</p>
                </Col>
              </Row>
            </Card>
            <Card className="p-3">
              <CardTitle>
                <div className="d-flex justify-content-between">
                  <h5>Access Credentials</h5>
                  <div style={{ textAlignLast: 'right' }}>
                    <Button style={{ backgroundColor: Utils.themeColor }} onClick={() => { if (data?.oppor?.length > 0) setForm(true); else setIsOpporForm(true); }}>
                      +Add
                    </Button>
                  </div>
                </div>
              </CardTitle>
              <DataTable
                columns={columns}
                data={data.managers}
                pagination
                customStyles={{
                  headCells: {
                    style: {
                      color: 'black',
                      fontWeight: 'bold',
                      fontSize: 15,
                      maxWidth: 80
                    },
                  },
                  cells: {
                    style: {
                      maxWidth: 50
                    }
                  }
                }}
              />
            </Card>
          </Col>
        </Row>
      </Row>
    </React.Fragment>
  )
}

export default LeadSingle;
